import { Box, Text } from '@chakra-ui/react'
import { PrimitiveAtom, useAtom } from 'jotai'

import { currentEnv } from '@/env/vars'
import { chatSettingsAtom } from '@/store/gigiChat/ChatAtom'
import { IConversationSettings } from '@/types/gigiChat/ConversationSettings'

const UploadQuestionMarkup = ({ value }: { value: string }) => {
    const [chatSettings] = useAtom<PrimitiveAtom<IConversationSettings | null>>(chatSettingsAtom)

    if (
        (currentEnv.features.isEnabled('useAgent') &&
            chatSettings?.processingStrategyQa.mode === 'normal' &&
            !chatSettings?.processingModeAgent &&
            chatSettings?.processingStrategy === 'QA') ||
        (chatSettings?.processingStrategy === 'Writing' && currentEnv.features.isEnabled('imageUnderstanding'))
    ) {
        const [command, fileList] = value.split(':').map((part) => part.trim())
        const files = fileList?.split(',').map((file) => file.trim()) || []

        return (
            <Box>
                <Box>{command}:</Box>
                {files.map((file, index) => (
                    <Box key={index} mt="16px" display="flex" alignItems="center">
                        <Text fontSize="14px" letterSpacing="0.25px">
                            {file.trim()}
                        </Text>
                    </Box>
                ))}
            </Box>
        )
    }

    return null
}

export default UploadQuestionMarkup
